/* =============================================================
   Pastel Sixteen — Signature Collection
   Handles: gender tabs, view toggle, sort, image carousel,
            quick-add modal, Swym wishlist re-init.
============================================================= */

(function () {
  'use strict';

  var LOW_STOCK_THRESHOLD = 3;

  /* ── Tiny DOM helpers ─────────────────────────────────────── */

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function escHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }


  /* ── Boot ─────────────────────────────────────────────────── */

  function init() {
    qsa('.sig-col').forEach(initSection);
  }

  function initSection(section) {
    initTabs(section);
    initViewToggle(section);
    initSort(section);
    initCarousels(section);
    initQuickAdd(section);
  }


  /* ── Gender tabs ──────────────────────────────────────────── */

  function initTabs(section) {
    var tabs  = qsa('.sig-col__tab', section);
    var grids = qsa('.sig-col__grid', section);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var gender = tab.dataset.tab;

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('sig-col__tab--active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        grids.forEach(function (grid) {
          grid.classList.toggle('sig-col__grid--visible', grid.dataset.gender === gender);
        });
      });
    });
  }


  /* ── View-density toggle ──────────────────────────────────── */

  function initViewToggle(section) {
    var btns   = qsa('.sig-col__view-btn', section);
    var label  = qs('.sig-col__view-label', section);
    var grids  = qsa('.sig-col__grid', section);

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.dataset.cols;

        btns.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('sig-col__view-btn--active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        grids.forEach(function (grid) {
          grid.style.gridTemplateColumns = cols === '1' ? '1fr' : 'repeat(2, 1fr)';
        });

        if (label) {
          label.textContent = cols === '1' ? '1 per row' : '2 per row';
        }
      });
    });
  }


  /* ── Sort ─────────────────────────────────────────────────── */

  function initSort(section) {
    var wrap   = qs('[data-sort-wrap]', section);
    if (!wrap) return;

    var toggle  = qs('[data-sort-toggle]', wrap);
    var list    = qs('[data-sort-list]', wrap);
    var options = qsa('.sig-col__sort-option', list);
    var sortLabel = qs('[data-sort-label]', toggle);
    var grids   = qsa('.sig-col__grid', section);

    /* Stamp original DOM order once */
    grids.forEach(function (grid) {
      qsa('.sig-product-card', grid).forEach(function (card, i) {
        card.dataset.originalIndex = i;
      });
    });

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = wrap.hasAttribute('data-open');
      isOpen ? closeSort(wrap, toggle) : openSort(wrap, toggle);
    });

    /* Close on outside click */
    document.addEventListener('click', function () {
      closeSort(wrap, toggle);
    });

    list.addEventListener('click', function (e) { e.stopPropagation(); });

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        var key = opt.dataset.sort;

        options.forEach(function (o) {
          var active = o === opt;
          o.classList.toggle('sig-col__sort-option--active', active);
          o.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        if (sortLabel) sortLabel.textContent = opt.textContent;

        grids.forEach(function (grid) { sortGrid(grid, key); });

        closeSort(wrap, toggle);
      });
    });
  }

  function openSort(wrap, toggle) {
    wrap.setAttribute('data-open', '');
    toggle.setAttribute('aria-expanded', 'true');
  }

  function closeSort(wrap, toggle) {
    wrap.removeAttribute('data-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  function sortGrid(grid, key) {
    var cards = qsa('.sig-product-card', grid);

    cards.sort(function (a, b) {
      switch (key) {
        case 'price-asc':
          return Number(a.dataset.productPrice) - Number(b.dataset.productPrice);
        case 'price-desc':
          return Number(b.dataset.productPrice) - Number(a.dataset.productPrice);
        case 'title-asc':
          return (a.dataset.productTitle || '').localeCompare(b.dataset.productTitle || '');
        case 'title-desc':
          return (b.dataset.productTitle || '').localeCompare(a.dataset.productTitle || '');
        default: /* manual — restore original order */
          return Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
      }
    });

    /* Re-append in sorted order */
    cards.forEach(function (card) { grid.appendChild(card); });
  }


  /* ── Image carousels ──────────────────────────────────────── */

  function initCarousels(section) {
    qsa('.sig-product-card__images', section).forEach(function (track) {
      var card = track.closest('.sig-product-card');
      var bar  = qs('[data-colour-bar]', card);

      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var idx = Math.round(track.scrollLeft / track.offsetWidth);
          if (bar) bar.style.setProperty('--bar-index', idx);
        }, 50);
      }, { passive: true });

      /* Cancel link navigation when the user has swiped the carousel */
      var scrollAtPointerDown = 0;
      track.addEventListener('pointerdown', function () {
        scrollAtPointerDown = track.scrollLeft;
      });
      track.addEventListener('click', function (e) {
        if (Math.abs(track.scrollLeft - scrollAtPointerDown) > 4) {
          e.preventDefault();
        }
      });
    });
  }


  /* ── Quick-add modal ──────────────────────────────────────── */

  function initQuickAdd(section) {
    var sectionId = section.dataset.sectionId;
    var modal    = qs('[data-quick-add-modal="' + sectionId + '"]');
    var backdrop = qs('[data-quick-add-backdrop="' + sectionId + '"]');
    var closeBtn = modal && qs('[data-quick-add-close]', modal);
    var inner    = modal && qs('[data-quick-add-inner]', modal);
    if (!modal || !inner) return;

    var activeCartBtn = null;

    function deactivateCartBtn() {
      if (activeCartBtn) {
        activeCartBtn.classList.remove('sig-product-card__cart-btn--active');
        activeCartBtn = null;
      }
    }

    /* Delegate to cart buttons inside this section */
    section.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-add]');
      if (!trigger) return;

      var productId = trigger.dataset.quickAdd;
      var card = qs('[data-product-id="' + productId + '"]', section);
      if (!card) return;

      var jsonEl = qs('[data-product-json]', card);
      if (!jsonEl) return;

      var product;
      try {
        product = JSON.parse(jsonEl.textContent);
      } catch (err) {
        console.error('[Pastel Sixteen] Quick-add JSON parse error:', err);
        return;
      }

      /* Read colours from data attributes — direct from Liquid, no JSON path */
      product.brand_colour_100 = card.dataset.colourBg   || '#ffffff';
      product.brand_colour_200 = card.dataset.colourSize || product.brand_colour;
      product.brand_colour_800 = card.dataset.colourText || product.brand_colour;

      deactivateCartBtn();
      activeCartBtn = trigger;
      trigger.classList.add('sig-product-card__cart-btn--active');

      openModal(modal, backdrop, inner, product);
    });

    /* Close handlers */
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { closeModal(modal, backdrop); deactivateCartBtn(); });
    }
    if (backdrop) {
      backdrop.addEventListener('click', function () { closeModal(modal, backdrop); deactivateCartBtn(); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal(modal, backdrop);
        deactivateCartBtn();
      }
    });
  }

  function openModal(modal, backdrop, inner, product) {
    /* Render content */
    inner.innerHTML = buildModalHTML(product);

    /* Apply brand colour CSS variables */
    var colour = product.brand_colour || '#3A2F2A';
    modal.style.setProperty('--qa-colour',           colour);
    modal.style.setProperty('--qa-text',             product.brand_colour_800 || colour);
    modal.style.setProperty('--qa-size-selected-bg', product.brand_colour_200 || colour);

    /* Set background directly — avoids CSS variable empty-string invalidation */
    modal.style.backgroundColor = product.brand_colour_100 || '#ffffff';

    /* Show */
    modal.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.classList.add('quick-add__backdrop--open');
    document.body.style.overflow = 'hidden';

    /* Wire up size buttons */
    var selectedVariantId = null;
    var checkoutBtn = qs('.quick-add__btn-checkout', inner);
    var sizeBtns    = qsa('.quick-add__size-btn:not(.quick-add__size-btn--unavailable)', inner);

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeBtns.forEach(function (b) {
          b.classList.remove('quick-add__size-btn--selected');
        });
        btn.classList.add('quick-add__size-btn--selected');
        selectedVariantId = btn.dataset.variantId;
        if (checkoutBtn) {
          checkoutBtn.disabled = false;
          checkoutBtn.textContent = 'Add to bag';
        }
      });
    });

    /* Add to cart then open cart drawer */
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        if (!selectedVariantId) return;
        addToCart(selectedVariantId, checkoutBtn, inner, modal, backdrop);
      });
    }

    /* Move focus inside modal */
    var firstFocusable = qs('button, a, input', modal);
    if (firstFocusable) firstFocusable.focus();
  }

  function closeModal(modal, backdrop) {
    modal.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('quick-add__backdrop--open');
    document.body.style.overflow = '';
  }

  function addToCart(variantId, checkoutBtn, inner, modal, backdrop) {
    checkoutBtn.setAttribute('data-loading', '');
    checkoutBtn.disabled = true;
    checkoutBtn.textContent = 'Adding…';

    var errEl = qs('.quick-add__error', inner);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(function (resp) {
      if (!resp.ok) return resp.json().then(function (data) { throw new Error(data.description || 'Add to cart failed'); });
      return resp.json();
    })
    .then(function () {
      closeModal(modal, backdrop);
      qsa('.sig-product-card__cart-btn--active').forEach(function (btn) {
        btn.classList.remove('sig-product-card__cart-btn--active');
      });
      if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
        window.CartDrawer.refresh();
      }
      if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
        window.CartDrawer.open();
      } else {
        document.dispatchEvent(new CustomEvent('cart-drawer:open'));
      }
    })
    .catch(function (err) {
      checkoutBtn.removeAttribute('data-loading');
      checkoutBtn.disabled = false;
      checkoutBtn.textContent = 'Add to bag';
      if (errEl) {
        errEl.textContent = err.message || 'Something went wrong. Please try again.';
        errEl.classList.add('quick-add__error--visible');
      }
    });
  }

  function buildModalHTML(product) {
    var variants = product.variants || [];

    var sizesHTML = variants.map(function (v) {
      var unavailable = !v.available;
      var lowStock    = v.available
        && v.inventory_management
        && v.inventory_quantity > 0
        && v.inventory_quantity <= LOW_STOCK_THRESHOLD;

      return [
        '<button',
        ' class="quick-add__size-btn', unavailable ? ' quick-add__size-btn--unavailable' : '', '"',
        ' data-variant-id="', v.id, '"',
        unavailable ? ' disabled aria-disabled="true"' : '',
        ' type="button"',
        ' aria-label="Size ', escHtml(v.title), unavailable ? ', unavailable' : '', '"',
        '>',
        escHtml(v.title),
        lowStock ? '<span class="quick-add__size-stock">' + v.inventory_quantity + ' left</span>' : (unavailable ? '<span class="quick-add__size-stock">Sold out</span>' : ''),
        '</button>'
      ].join('');
    }).join('');

    var imgHTML = product.image
      ? '<img src="' + escHtml(product.image) + '" alt="' + escHtml(product.title) + '" class="quick-add__product-img" loading="lazy" width="80" height="80">'
      : '';

    var taglineHTML = product.what_four_words
      ? '<p class="quick-add__product-tagline">' + escHtml(product.what_four_words) + '</p>'
      : '';

    return [
      '<div class="quick-add__product-header">',
        imgHTML,
        '<div class="quick-add__product-meta">',
          '<p class="quick-add__product-name">', escHtml(product.title), '</p>',
          taglineHTML,
          '<p class="quick-add__product-price">', escHtml(product.price_formatted), '</p>',
        '</div>',
      '</div>',

      '<div class="quick-add__size-header">',
        '<span class="quick-add__size-label">Select Size</span>',
      '</div>',

      '<div class="quick-add__sizes">', sizesHTML, '</div>',

      '<div class="quick-add__actions">',
        '<a href="', escHtml(product.url), '" class="quick-add__btn-pdp">View Details</a>',
        '<button class="quick-add__btn-checkout" type="button" disabled>Select a size</button>',
        '<p class="quick-add__error" role="alert"></p>',
      '</div>'
    ].join('');
  }


  /* ── Shopify section events (theme editor) ────────────────── */

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.sig-col');
    if (section) initSection(section);
  });


  /* ── Run ──────────────────────────────────────────────────── */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
